import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Navbar from '../../components/Navbar/Navbar';
import './Contactus.scss';
import Footer from '../../components/Footer/Footer';
import ContactSection from './sections/ContactSection/ContactSection';
import Appointment from '../../components/Appointment/Appointment';
import ServiceBanner from '../../components/ServiceBanner/ServiceBanner';
import { FaCheck, FaExclamation } from "react-icons/fa6";
import {Link} from 'react-router-dom';
import {Helmet} from 'react-helmet-async';
const data = {
    registrationIfoItems: [
        {
            icon: <FaCheck size={20} className='check-icon' />,
            title: 'Jeśli szukasz lekarza według specjalizacji, wybierz odpowiednią dziedzinę z listy </br> w pierwszym polu („Wybierz specjalizację/lekarza”), a następnie kliknij „Sprawdź terminy”. System wyświetli dostępnych lekarzy oraz wolne godziny wizyt.'
        },
        {icon: <FaCheck size={20} className='check-icon'/>, title: 'Jeżeli chcesz zapisać się do konkretnego specjalisty, wystarczy wpisać jego nazwisko w tym samym polu i zarezerwować termin.'},
        {icon: <FaCheck size={20} className='check-icon'/>, title: 'Domyślnie system sugeruje dzisiejszą datę, jednak jeśli interesuje Cię późniejszy termin, możesz go zmienić – wtedy pojawią się dostępne opcje w wybranym okresie.'},
        {icon: <FaExclamation size={20} className='check-icon'/>, title: 'W przypadku wielokrotnego niepojawienia się na wizytach, częstego przekładania terminów lub braku kontaktu, system może zablokować możliwość rezerwacji online. W takiej sytuacji konieczna będzie przedpłata za wizytę po wcześniejszym ustaleniu terminu telefonicznie.'}
    ],
    buttonregistrationtextText: 'Rejestracja online MYDR',
}

const Contactus = () => {
    return (
        <>
            <Helmet>
                            <title>Złota Centrum Zdrowia | Kontakt</title>
                            <meta
                              name="description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                            {/* Open Graph / Facebook */}
                            <meta property="og:type" content="website" />
                            <meta property="og:url" content={window.location.href} />
                            <meta property="og:title" content="Złota Centrum Zdrowia | Kontakt" />
                            <meta
                              property="og:description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                    
                            {/* Twitter */}
                            <meta property="twitter:card" content="summary" />
                            <meta property="twitter:url" content={window.location.href} />
                            <meta property="twitter:title" content="Złota Centrum Zdrowia | Kontakt" />
                            <meta
                              property="twitter:description"
                              content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                            />
                          </Helmet>
            <Navbar />
            <ServiceBanner title="Kontakt" subTitle="Kontakt" />
            {/* Sekcja Rejestracji */}
            <section className="section-common container registration-section section-pt section-m">
            <SectionTitle title="Rejestracja online" description="Poprzez poniższy przycisk (Rejestracja Online MYDR) możesz łatwo i szybko umówić wizytę online." />   
                <div className="registration-list">
                <div className="registration-item">
                                <div className="registration-item-icon"><FaCheck size={20} className='check-icon'/></div>
                                <p>Jeśli szukasz lekarza według specjalizacji, wybierz odpowiednią dziedzinę z listy <br /> w pierwszym polu („Wybierz specjalizację/lekarza”), a następnie kliknij „Sprawdź terminy”. System wyświetli dostępnych lekarzy oraz wolne godziny wizyt.</p>
                    </div>
                    <div className="registration-item">
                                <div className="registration-item-icon"><FaCheck size={20} className='check-icon'/></div>
                                <p>Jeżeli chcesz zapisać się do konkretnego specjalisty, wystarczy wpisać jego nazwisko w tym samym polu i zarezerwować termin.</p>
                    </div>
                    <div  className="registration-item">
                                <div className="registration-item-icon"><FaCheck size={20} className='check-icon'/></div>
                                <p>Domyślnie system sugeruje dzisiejszą datę, jednak jeśli interesuje Cię późniejszy termin, możesz go zmienić – wtedy pojawią się dostępne opcje w wybranym okresie.</p>
                    </div>
                    <div className="registration-item">
                                <div className="registration-item-icon"><FaExclamation size={20} className='check-icon'/></div>
                                <p>W przypadku wielokrotnego niepojawienia się na wizytach, częstego przekładania terminów lub braku kontaktu, system może zablokować możliwość rezerwacji online. W takiej sytuacji konieczna będzie przedpłata za wizytę po wcześniejszym ustaleniu terminu telefonicznie.</p>
                            </div>
                    </div>
            </section>
            <section className="registration-button-section section-common container">
                <Link target='_blank' to='https://mydr.pl/welcome' className="registration-button">{data.buttonregistrationtextText}</Link>
                </section>
            <ContactSection />
            <Appointment />
            <Footer />
        </>
    );
};

export default Contactus;
